import SearchRecordTable from "./Recordtable";

export default SearchRecordTable;
